"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceBreakDownPopOverPropTypes = exports.PriceBreakDownPopOverDefaultPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var PriceBreakDownPopOverPropTypes = {
  totalFlightSAPriceKey: _propTypes.default.string,
  totalHotelSAPriceKey: _propTypes.default.string,
  bundleSavingKey: _propTypes.default.string,
  totalFlightSAPrice: _propTypes.default.string,
  totalHotelSAPrice: _propTypes.default.string,
  bundleSavingPrice: _propTypes.default.string,
  totalBundlePrice: _propTypes.default.string,
  totalPayableText: _propTypes.default.string,
  perRoomNight: _propTypes.default.string,
  summaryNightKey: _propTypes.default.string,
  savingLabel: _propTypes.default.string,
  roomType: _propTypes.default.string,
  currency: _propTypes.default.string,
  theme: _propTypes.default.string,
  comboMessage: _propTypes.default.string,
  totalText: _propTypes.default.string,
  totalSAPrice: _propTypes.default.string,
  perPersonBundlePrice: _propTypes.default.string
};
exports.PriceBreakDownPopOverPropTypes = PriceBreakDownPopOverPropTypes;
var PriceBreakDownPopOverDefaultPropTypes = {
  totalFlightSAPriceKey: '',
  totalHotelSAPriceKey: '',
  bundleSavingKey: '',
  totalFlightSAPrice: '',
  totalHotelSAPrice: '',
  bundleSavingPrice: '',
  totalBundlePrice: '',
  totalPayableText: '',
  perRoomNight: '',
  summaryNightKey: '',
  savingLabel: '',
  roomType: '',
  currency: '',
  theme: '',
  comboMessage: '',
  totalText: '',
  totalSAPrice: '',
  perPersonBundlePrice: ''
};
exports.PriceBreakDownPopOverDefaultPropTypes = PriceBreakDownPopOverDefaultPropTypes;